const RAD = Math.PI / 180;

// Sunrise/sunset in UTC minutes for a date at lat/lng (zenith 90.833 deg).
export function sunTimesUTC(dateStr, lat, lng) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const N = Math.floor((Date.UTC(y, m - 1, d) - Date.UTC(y, 0, 0)) / 86400000);
  const lngHour = lng / 15;
  const calc = (isSunrise) => {
    const t = N + ((isSunrise ? 6 : 18) - lngHour) / 24;
    const M = 0.9856 * t - 3.289;
    let L = (M + 1.916 * Math.sin(M * RAD) + 0.020 * Math.sin(2 * M * RAD) + 282.634) % 360;
    if (L < 0) L += 360;
    let RA = Math.atan(0.91764 * Math.tan(L * RAD)) / RAD;
    if (RA < 0) RA += 360;
    RA += Math.floor(L / 90) * 90 - Math.floor(RA / 90) * 90;
    RA /= 15;
    const sinDec = 0.39782 * Math.sin(L * RAD);
    const cosDec = Math.cos(Math.asin(sinDec));
    const cosH = (Math.cos(90.833 * RAD) - sinDec * Math.sin(lat * RAD)) / (cosDec * Math.cos(lat * RAD));
    if (cosH > 1 || cosH < -1) return null;
    let H = Math.acos(cosH) / RAD / 15;
    if (isSunrise) H = 24 - H;
    const T = H + RA - 0.06571 * t - 6.622;
    let UT = (T - lngHour) % 24;
    if (UT < 0) UT += 24;
    return Math.round(UT * 60);
  };
  const sunrise = calc(true);
  const sunset = calc(false);
  if (sunrise == null || sunset == null) return null;
  return { sunrise, sunset };
}

export function localOffsetMin(location) {
  if (!location) return 0;
  return Math.round(location.lng / 15) * 60 + (location.dst ? 60 : 0);
}

export function sunTimesLocal(dateStr, lat, lng, offsetMin) {
  const s = sunTimesUTC(dateStr, lat, lng);
  if (!s) return null;
  return {
    sunrise: (s.sunrise + offsetMin + 1440) % 1440,
    sunset: (s.sunset + offsetMin + 1440) % 1440,
  };
}
